/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PostTemplatesRoute extends Route {
  queryParams = {
    pageType: {
      refreshModel: true,
      as: 'type',
    },
  };

  // Services
  @service
  schoolSchema;

  @service
  session;

  @service
  store;

  model(params) {
    let store = this.store;

    return hash({
      fieldGroups: this.schoolSchema.getPeopleSchema(),
      postTemplates: store.query('posts/post-template', {
        type: params.pageType,
      }),
      staff: this.store.query('person', { type: PersonType.STAFF }),
      staffUsers: this.store.query('user', {
        allowedTenantAccess: this.session.activeSchool,
        scopesUnion:
          'urn:linced:organisation:role:staff,urn:linced:organisation:role:admin',
      }),
    });
  }
}
